import React from 'react';

import { useCurrentUserPermissions } from 'src/hooks/user';
import { NotFoundErrorPage } from 'src/pages/not-found';

import {
  DataDisputeReportTableCVAdmin,
  DataDisputeReportTableEmployerAdmin,
  DataDisputeReportTableEmployerManager,
  DataDisputeReportTablePEOPayrollProvider,
} from './components';
import { DataDisputeReportTableCVManager } from './components/DataDisputeReportTableCVManager';
import { DataDisputeReportTablePEOAdmin } from './components/DataDisputeReportTablePEOAdmin';
import { DataDisputeReportTablePEOManager } from './components/DataDisputeReportTablePEOManager';

export const DataDisputeReportTable: React.FC = () => {
  const {
    isPlatformAdmin,
    isPlatformManager,
    isEmployerAdmin,
    isEmployerManager,
    isPeoSuperAdmin,
    isPeoAdmin,
    isPeoManager,
    isPeoPayrollProviderUser,
  } = useCurrentUserPermissions();

  if (isPlatformAdmin) return <DataDisputeReportTableCVAdmin />;
  if (isPlatformManager) return <DataDisputeReportTableCVManager />;

  if (isEmployerAdmin) return <DataDisputeReportTableEmployerAdmin />;
  if (isEmployerManager) return <DataDisputeReportTableEmployerManager />;

  if (isPeoSuperAdmin || isPeoAdmin) return <DataDisputeReportTablePEOAdmin />;
  if (isPeoManager) return <DataDisputeReportTablePEOManager />;
  if (isPeoPayrollProviderUser) return <DataDisputeReportTablePEOPayrollProvider />;

  return <NotFoundErrorPage />;
};
